import { ActivityTableRow_ActivityFragment } from 'generated/graphql'

const CATEGORIES_LIMIT_LENGTH = 2

/**
 * @desc 공고 카테고리 데이터를 받아서 텍스트로 반환합니다.
 * @desc 카테고리가 없으면 '-'를 반환합니다.
 * @desc 카테고리가 2개 이상이면 2개까지만 반환하고, 나머지는 '외 n개'로 표시합니다.
 * @param {ActivityTableRow_ActivityFragment['categories']} categories 공고 카테고리 데이터
 * @returns {string}
 */
export const getCategoriesText = (
  categories: ActivityTableRow_ActivityFragment['categories'],
): string => {
  const categoryArr = (categories ?? []).map((category) => category?.name)
  if (categoryArr.length === 0) {
    return '-'
  } else if (categoryArr.length > CATEGORIES_LIMIT_LENGTH) {
    return (
      categoryArr.slice(0, CATEGORIES_LIMIT_LENGTH).join(', ') +
      ` 외 ${categoryArr.length - CATEGORIES_LIMIT_LENGTH}`
    )
  } else {
    return categoryArr.join(', ')
  }
}

export const CATEGORY_IDS = {
  PROGRAMMING: '559', // 프로그래밍
  DATA_SCIENCE: '562', // 데이터사이언스
  AI: '566', // 인공지능
  IOT: '615', // IoT · 임베디드 · 반도체
  CLOUD_SECURITY: '620', // 클라우드 · 보안
  PRODUCTIVITY: '563', // 업무생산성
  BUSINESS: '561', // 비즈니스
  MARKETING: '564', // 기획 · 마케팅
  DESIGN: '565', // 디자인
  ILLUSTRATION: '560', // 일러스트
  VIDEO_3D: '567', // 영상 · 3D
  FINANCE: '568', // 금융 · 투자
  LIFESTYLE: '626', // 라이프스타일
  OTHER: '636', // 기타
}

export const CATEGORY_CHIP_COLOR = {
  [CATEGORY_IDS.PROGRAMMING]: { backgroundColor: '#fff8f8', color: '#dc5252' },
  [CATEGORY_IDS.DATA_SCIENCE]: { backgroundColor: '#fff8fc', color: '#ce4293' },
  [CATEGORY_IDS.AI]: { backgroundColor: '#fff9f0', color: '#ed671b' },
  [CATEGORY_IDS.IOT]: { backgroundColor: '#fffbeb', color: '#a75d00' },
  [CATEGORY_IDS.CLOUD_SECURITY]: {
    backgroundColor: '#f6ffdd',
    color: '#226900',
  },
  [CATEGORY_IDS.PRODUCTIVITY]: { backgroundColor: '#fffbeb', color: '#a75d00' },
  [CATEGORY_IDS.BUSINESS]: { backgroundColor: '#fff9f0', color: '#ed671b' },
  [CATEGORY_IDS.MARKETING]: { backgroundColor: '#f4fcff', color: '#008bc1' },
  [CATEGORY_IDS.DESIGN]: { backgroundColor: '#f4f8ff', color: '#0014ff' },
  [CATEGORY_IDS.ILLUSTRATION]: { backgroundColor: '#fafafa', color: '#333333' },
  [CATEGORY_IDS.VIDEO_3D]: { backgroundColor: '#faf8ff', color: '#ba00ff' },
  [CATEGORY_IDS.FINANCE]: { backgroundColor: '#f0f0f0', color: '#333333' },
  [CATEGORY_IDS.LIFESTYLE]: { backgroundColor: '#fafafa', color: '#333333' },
  [CATEGORY_IDS.OTHER]: { backgroundColor: '#f8faff', color: '#333333' },
  default: { backgroundColor: '#f8faff', color: '#333333' },
}
